import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyle = makeStyles({
	flex0: {
		...shorthands.flex(0),
	},
	borderRadius: {
		...shorthands.borderRadius('8px'),
	},
	margin: {
		...shorthands.margin('0px', '10px'),
	},
	dataIconSize: {
		fontSize: '48px',
	},
	profilingPage: {
		...shorthands.padding('8px'),
		height: '100%',
	},
	backgroundColor: {
		backgroundColor: tokens.colorNeutralBackground4,
	},
	flexGrow: {
		flexGrow: 1,
	},
	width80: {
		width: '80%',
	},
	maxHeight80: {
		maxHeight: 'calc(100% - 105px)',
	},
	smallFont: {
		fontSize: tokens.fontSizeBase200,
	},
	paddingLeftRight: {
		...shorthands.padding(0, '5px'),
	},
});

export default useStyle;
